module.exports = __webpack_public_path__ + "img/idcard-index.4cb77ac9.png";